import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {

    // --- ANIMATION HERO ---
    const heroSection = document.querySelector('.pdw-banner-intro');
    if (heroSection) {

        // 1. TIMELINE DE CHARGEMENT (Apparition + Zoom fond)
        const heroTl = gsap.timeline({
            defaults: {ease: "power3.out", duration: 1}
        });

        // On lance un zoom très lent sur l'image de fond (dure 10 secondes)
        // On cible la balise <img> à l'intérieur de notre nouvelle classe
        heroTl.from(".gsap-hero-badge", {y: 20, opacity: 0, duration: 0.8}, 0) // Démarre en même temps (à 0s)
            .from(".gsap-hero-title", {y: 30, opacity: 0}, "-=0.5")
            .from(".gsap-hero-text", {y: 20, opacity: 0}, "-=0.7")
            .from(".gsap-hero-form", {x: 40, opacity: 0, duration: 1.2}, "-=0.8");


        // 2. PARALLAX AU SCROLL
        // Quand on commence à scroller vers le bas, on fait remonter les éléments
        // à des vitesses différentes pour créer un effet 3D.

        // Le bloc texte de gauche remonte légèrement
        gsap.to(".gsap-hero-title, .gsap-hero-text, .gsap-hero-badge", {
            y: -50, // Déplacement vers le haut
            ease: "none",
            scrollTrigger: {
                trigger: heroSection,
                start: "top top", // Démarre quand le haut du hero est en haut de l'écran
                end: "bottom top", // Finit quand le bas du hero atteint le haut de l'écran
                scrub: true // L'animation suit exactement la molette de la souris !
            }
        });

        // Le formulaire remonte un peu plus vite que le texte (effet de profondeur)
        gsap.to(".gsap-hero-form", {
            y: -80,
            ease: "none",
            scrollTrigger: {
                trigger: heroSection,
                start: "top top",
                end: "bottom top",
                scrub: true
            }
        });
    }
// --- ANIMATION SECTION DÉMÉNAGEMENTS ---
    const demenagementSection = document.querySelector('.gsap-demenagement-section');
    if (demenagementSection) {
        // Création de la timeline liée au scroll
        const demenagementTl = gsap.timeline({
            scrollTrigger: {
                trigger: demenagementSection,
                start: "top 80%", // L'animation se lance quand le haut de la section est à 80% de l'écran
            }
        });

        // 1. Apparition du titre, texte et bouton de gauche
        // En utilisant '> *', on cible les enfants directs pour les animer un par un
        demenagementTl.from(".gsap-demenagement-header > *", {
            y: 30,
            opacity: 0,
            duration: 0.6,
            stagger: 0.15, // Titre, puis texte, puis bouton
            ease: "power2.out"
        })
            // 2. Apparition des 4 cartes en cascade
            .from(".gsap-demenagement-card", {
                y: 50,
                opacity: 0,
                duration: 0.8,
                stagger: 0.15, // Le fameux effet vague sur les cartes
                ease: "power2.out"
            }, "-=0.3"); // "-=0.3" permet aux cartes de commencer à apparaître avant que le texte ne soit totalement fini

        // --- BONUS : EFFET HOVER SUR LES CARTES ---
        // On crée un petit zoom sur l'image de fond quand la souris passe sur la carte
        const cards = document.querySelectorAll('.gsap-demenagement-card');

        cards.forEach(card => {
            const img = card.querySelector('img'); // On cible l'image générée par WP

            if (img) {
                // Au survol : l'image grossit légèrement
                card.addEventListener('mouseenter', () => {
                    gsap.to(img, {scale: 1.07, duration: 0.4, ease: "power2.out"});
                });
                // Quand la souris part : l'image revient à sa taille normale
                card.addEventListener('mouseleave', () => {
                    gsap.to(img, {scale: 1, duration: 0.4, ease: "power2.out"});
                });
            }
        });
    }
// --- ANIMATION SECTION LOCATION ---
    const locationSection = document.querySelector('.gsap-location-section');
    if (locationSection) {
        const locationTl = gsap.timeline({
            scrollTrigger: {
                trigger: locationSection,
                start: "top 80%",
            }
        });

        // 1. Apparition du titre et texte du haut
        locationTl.from(".gsap-location-header > *", {
            y: 30,
            opacity: 0,
            duration: 0.6,
            stagger: 0.15,
            ease: "power2.out"
        })
            // 2. Apparition des cartes en cascade (comme la section déménagement)
            .from(".gsap-location-card", {
                y: 50,
                opacity: 0,
                duration: 0.8,
                stagger: 0.15,
                ease: "power2.out"
            }, "-=0.3")
            // 3. Apparition du bloc de réassurance (bleu) par la droite
            .from(".gsap-location-reassurance", {
                x: 40, // Il vient de la droite
                opacity: 0,
                duration: 0.8,
                ease: "power3.out"
            }, "-=0.6"); // Se déclenche pendant que les cartes apparaissent

        // --- BONUS : EFFET HOVER SUR LES CARTES DE LOCATION ---
        // On réutilise la même logique de zoom que pour les déménagements
        const locationCards = document.querySelectorAll('.gsap-location-card');

        locationCards.forEach(card => {
            const img = card.querySelector('img');

            if (img) {
                card.addEventListener('mouseenter', () => {
                    gsap.to(img, {scale: 1.07, duration: 0.4, ease: "power2.out"});
                });
                card.addEventListener('mouseleave', () => {
                    gsap.to(img, {scale: 1, duration: 0.4, ease: "power2.out"});
                });
            }
        });
    }
    // --- ANIMATION SECTION ÉTAPES (01, 02, 03) ---
    const stepsSection = document.querySelector('.gsap-steps-section');
    if (stepsSection) {

        // 1. L'apparition standard (Timeline)
        const stepsTl = gsap.timeline({
            scrollTrigger: {
                trigger: stepsSection,
                start: "top 80%"
            }
        });

        // Apparition du texte descriptif
        stepsTl.from(".gsap-steps-header > *", {
            y: 30,
            opacity: 0,
            duration: 0.6,
            stagger: 0.15,
            ease: "power2.out"
        })
            // Apparition des 3 colonnes de bas en haut
            .from(".gsap-steps-card", {
                y: 50,
                opacity: 0,
                duration: 0.8,
                stagger: 0.2, // Délai un peu plus long pour bien voir le 1, 2, 3
                ease: "power2.out"
            }, "-=0.3");


        // 2. L'effet PARALLAX sur les grands numéros
        // On lie le mouvement des chiffres directement au défilement de la molette
        gsap.to(".gsap-step-number", {
            y: -40, // Les numéros vont monter de 40px vers le haut
            ease: "none",
            scrollTrigger: {
                trigger: stepsSection,
                start: "top bottom", // Démarre quand la section entre par le bas de l'écran
                end: "bottom top",   // Finit quand la section sort par le haut
                scrub: 1 // Le "1" adoucit le mouvement pour qu'il ne soit pas saccadé
            }
        });

        // 3. BONUS : Effet de zoom sur l'image au survol (cohérence avec les autres sections)
        const stepCards = document.querySelectorAll('.gsap-steps-card');

        stepCards.forEach(card => {
            // On cherche l'image à l'intérieur de la carte
            const img = card.querySelector('.pdw-service-filter img');

            if (img) {
                card.addEventListener('mouseenter', () => {
                    gsap.to(img, {scale: 1.05, duration: 0.4, ease: "power2.out"});
                });
                card.addEventListener('mouseleave', () => {
                    gsap.to(img, {scale: 1, duration: 0.4, ease: "power2.out"});
                });
            }
        });
    }
    // --- ANIMATION SECTION CONFIANCE (ICÔNES) ---
    const trustSection = document.querySelector('.gsap-trust-section');

    if (trustSection) {
        // 1. Apparition au scroll
        const trustTl = gsap.timeline({
            scrollTrigger: {
                trigger: trustSection,
                start: "top 85%", // Déclenchement un peu plus tôt pour que ça démarre vite
            }
        });

        // Apparition du texte
        trustTl.from(".gsap-trust-header > *", {
            y: 30,
            opacity: 0,
            duration: 0.6,
            stagger: 0.1,
            ease: "power2.out"
        })
            // Apparition des 5 blocs (cascade rapide)
            .from(".gsap-trust-item", {
                y: 30,
                opacity: 0,
                duration: 0.5,
                stagger: 0.1, // Délai très court pour un effet d'onde rapide
                ease: "power2.out"
            }, "-=0.3");

        // 2. BONUS : Effet de rebond tactile au survol des éléments
        const trustItems = document.querySelectorAll('.gsap-trust-item');

        trustItems.forEach(item => {
            const icon = item.querySelector('.gsap-trust-icon');

            if (icon) {
                // Au survol : l'icône monte légèrement et s'agrandit avec un effet "ressort"
                item.addEventListener('mouseenter', () => {
                    gsap.to(icon, {
                        y: -8,
                        scale: 1.1,
                        duration: 0.4,
                        ease: "back.out(2)" // C'est ça qui donne l'effet de léger rebond élastique !
                    });
                });

                // Au retrait de la souris : retour à la normale fluide
                item.addEventListener('mouseleave', () => {
                    gsap.to(icon, {
                        y: 0,
                        scale: 1,
                        duration: 0.3,
                        ease: "power2.out"
                    });
                });
            }
        });
    }
    // --- ANIMATION SECTION RÉFÉRENCE (CHIFFRES CLÉS) ---
    const referenceSection = document.querySelector('.gsap-reference-section');

    if (referenceSection) {
        const referenceTl = gsap.timeline({
            scrollTrigger: {
                trigger: referenceSection,
                start: "top 80%",
            }
        });

        // 1. Apparition du texte de gauche
        referenceTl.from(".gsap-reference-text > *:not(.position-relative.border-start)", {
            y: 30,
            opacity: 0,
            duration: 0.6,
            stagger: 0.15,
            ease: "power2.out"
        })
            // 2. Apparition de l'image de droite (elle glisse depuis la droite)
            .from(".gsap-reference-image", {
                x: 50,
                opacity: 0,
                duration: 1,
                ease: "power3.out"
            }, "-=0.6")
            // 3. Apparition du bloc de chiffres (la bordure rouge/secondaire)
            .from(".gsap-reference-text .border-start", {
                opacity: 0,
                x: -20,
                duration: 0.6,
                ease: "power2.out"
            }, "-=0.5");

        // 4. ANIMATION DES COMPTEURS (de 0 à X)
        const counters = document.querySelectorAll('.gsap-counter');

        counters.forEach(counter => {
            // On récupère le texte brut généré par le PHP (ex: "45+")
            const originalText = counter.innerText.trim();

            // On sépare le chiffre du symbole (RegEx magique)
            // number = 45, suffix = "+"
            const targetNumber = parseInt(originalText.replace(/[^0-9]/g, ''), 10);
            const suffix = originalText.replace(/[0-9]/g, '');

            // Si on a bien trouvé un nombre valide
            if (!isNaN(targetNumber)) {
                // On crée un objet temporaire pour que GSAP l'anime
                let zero = {val: 0};

                // On met visuellement le compteur à 0 au départ
                counter.innerText = "0" + suffix;

                // On anime la propriété 'val' de l'objet temporaire...
                referenceTl.to(zero, {
                    val: targetNumber,
                    duration: 2, // L'animation dure 2 secondes
                    ease: "power2.out",
                    // ...et à chaque milliseconde d'animation, on met à jour le texte dans le HTML
                    onUpdate: function () {
                        counter.innerText = Math.ceil(zero.val) + suffix;
                    }
                }, "-=1.5"); // On fait démarrer les compteurs pendant que l'image arrive
            }
        });
    }
});